{
  "name": "helpii",
  "version": "1.73.0",
  "scripts": {
    "dev": "yarn start",
    "start": "yarn generate:sprite && yarn ng-with-env serve --configuration=staging",
    "build": "yarn ng run helpii:build:staging",
    "build-storybook": "yarn generate:sprite && \\cp -r src/assets .storybook/public && ng run helpii:build-storybook",
    "build:app": "yarn generate:sprite && yarn ng run helpii:build --delete-output-path=false --deploy-url=https://cdn.wizbii.io/helpii/$CI_COMMIT_SHA/",
    "build:app:fr": "BUILD_LANG=fr BUILD_LOCALE=fr_FR yarn build:app",
    "test": "jest --maxWorkers=50%",
    "test:ci": "yarn test --ci --coverage",
    "check:ci": "run-p -c eslint:ci prettier:ci stylelint:ci",
    "eslint:ci": "yarn ng lint --format gitlab",
    "fix:lint": "run-p -c \"lint:ts --fix\" \"lint:pretty --write\"",
    "format": "prettier 'src/**/*.{ts,scss,js,json,yml,md,html}' --write",
    "lint": "run-p -c 'lint:*'",
    "lint:pretty": "prettier 'src/**/*.{ts,scss,js,json,yml,md,html}' --list-different",
    "lint:scss": "stylelint 'src/**/*.scss'",
    "lint:ts": "ng lint",
    "prettier:ci": "prettier --write --cache --cache-strategy metadata --cache-location './.prettiercache' 'src/**/*.{ts,scss,js,json,yml,md,html}'",
    "stylelint:ci": "stylelint --cache --cache-strategy metadata 'src/**/*.{ts,scss}'",
    "release": "release-it",
    "find-deadcode": "knip",
    "generate:sprite": "svg2sprite src/assets/svg src/assets/sprite.svg",
    "storybook": "yarn generate:sprite && cp -r src/assets .storybook/public && ng run helpii:storybook",
    "ng": "ng",
    "ng-with-env": "DOTENV_CONFIG_PATH=src/environments/.env.build.local node -r dotenv/config ./node_modules/.bin/ng",
    "prepare": "husky install"
  },
  "prettier": "@wizbii-tooling/prettier-config",
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/localize": "^21.2.18",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/platform-server": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@angular/ssr": "^21.2.19",
    "@bugsnag/browser-performance": "^2.11.0",
    "@bugsnag/js": "^8.2.0",
    "@bugsnag/plugin-angular": "^8.3.0",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/router-store": "^21.1.1",
    "@ngrx/signals": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@tailwindcss/postcss": "^4.0.14",
    "@wizbii-components/angular-styles": "5.29.4",
    "@wizbii-components/angular-ui": "5.29.4",
    "@wizbii-components/bo-angular-ui": "5.29.4",
    "@wizbii-components/bo-styles": "5.29.4",
    "@wizbii-components/styles": "5.29.4",
    "@wizbii-money/angular": "^6.24.0",
    "@wizbii-money/tailwindcss": "^6.24.0",
    "@wizbii-node/utils": "^5.2.7",
    "@wizbii-utils/angular": "^5.9.2",
    "@wizbii/algolia": "^6.1.2",
    "@wizbii/svg2sprite-cli": "2.1.0",
    "@wizbii/utils": "^5.9.2",
    "algoliasearch": "^4.24.0",
    "dayjs": "^1.11.13",
    "ngx-cookie-service": "^21.3.1",
    "ngx-pipes": "^3.2.2",
    "ngx-quicklink": "^0.4.7",
    "ngx-skeleton-loader": "^13.0.0",
    "ngxtension": "^7.2.0",
    "postcss": "^8.5.3",
    "query-string": "^9.4.1",
    "rxjs": "~7.8.2",
    "tailwind-merge": "^3.3.1",
    "tailwindcss": "^4.0.14",
    "tslib": "^2.8.1",
    "type-fest": "^4.37.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "^21.1.0",
    "@angular-devkit/architect": "0.2102.19",
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular-devkit/core": "^21.2.19",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@compodoc/compodoc": "^1.1.32",
    "@release-it/conventional-changelog": "^11.0.1",
    "@storybook/addon-a11y": "^10.5.1",
    "@storybook/addon-docs": "^10.5.1",
    "@storybook/angular": "^10.5.1",
    "@tailwindcss/postcss": "^4.0.14",
    "@types/jest": "^30.0.0",
    "@types/node": "~22.13.10",
    "@wizbii-tooling/eslint-config-angular": "^6.1.0",
    "@wizbii-tooling/prettier-config": "^6.1.0",
    "@wizbii-tooling/stylelint-config-scss": "^6.1.0",
    "dotenv": "^17.4.2",
    "esbuild-plugin-environment": "^0.4.0",
    "eslint": "^8.57.1",
    "eslint-formatter-gitlab": "^5.1.0",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^17.0.0",
    "knip": "^5.46.0",
    "nano-staged": "^1.0.2",
    "ng-mocks": "^14.15.3",
    "npm-run-all2": "^5.0.0",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "release-it": "^18.1.2",
    "storybook": "^10.5.1",
    "stylelint": "^16.15.0",
    "ts-jest": "^29.4.11",
    "typescript": "~5.9.3"
  },
  "resolutions": {
    "tailwindcss": "^4.0.14",
    "webpack": "^5.104.1"
  },
  "packageManager": "yarn@4.12.0",
  "nano-staged": {
    "*.{ts,html}": "yarn eslint --fix",
    "*.{ts,scss}": "yarn stylelint --fix",
    "*.{ts,html,js,json,yml,md,scss}": "yarn prettier --write"
  }
}
